import { Modal } from 'components';
import styled from 'styled-components';

export const ModalBody = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 24px;
  overflow: hidden;
`;

export const StyledModal = styled(Modal).attrs({
  wide: true,
})``;

export const Layout = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 4fr 1fr;
  height: calc(100vh - 200px);
  overflow: hidden;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    grid-template-rows: 4fr 1fr;
  }
`;
